import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { useFetchData } from "@dzambalaorg/react-hooks";
import type { ITemplate } from "@framework/types";

import { TemplateContent } from "../../../../components";

export const Erc721Template = () => {
  const { data: template, isLoading } = useFetchData<ITemplate>("/erc721/templates");

  if (isLoading) {
    return <Spinner />;
  }

  if (!template) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc721", "erc721.template"]} data={[{}, {}, template]} />

      <PageHeader message="pages.erc721.template.title" data={template} />

      <TemplateContent template={template} />
    </Fragment>
  );
};
